import {
  ACCESS_LEVEL_PURCHASE,
  ACCESS_LEVEL_VIEW,
} from "../../../../constants";

const getBadgeText = ({ formatTranslation, earlyAccess }) => {
  switch (earlyAccess?.customerAccess) {
    case ACCESS_LEVEL_VIEW:
      return formatTranslation("coming_soon_label");
    case ACCESS_LEVEL_PURCHASE:
      return formatTranslation("early_access_label");
    default:
      return null;
  }
};

export default getBadgeText;
